import { CloseIcon } from "../Icons/Icons";
import React from "react";


const CloseButton = ({ closeToast }) => (
  <div onClick={closeToast} className="closeIcon">
    <CloseIcon />
  </div>
);

export default CloseButton